// extracted by mini-css-extract-plugin
module.exports = {"pending":"styles_pending__1OwEg","selected":"styles_selected__3oFT7"};